export const toEmailPreferences = (emailsChecked, time) => {
  return {
    preferences: {
      dailyNotification: emailsChecked,
      notificationTime: time
    }
  }
}
